module.exports = __webpack_public_path__ + "static/media/btnNext.511f240b.svg";